import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Box, Typography } from '@material-ui/core';

const PinBox = ({ classes, boxName, pins, withMargin, additionalFnOnClick, dataForCache, browserHistory, history }) => {
  const hidePinLink = !browserHistory;

  const onPinClick = (pin) => {
    if (hidePinLink) return;

    history.push(`/performance/${pin.padStart(6, '0')}`);
    additionalFnOnClick(dataForCache);
  };

  const isSinglePin = typeof pins === 'string';

  const renderPinLink = (pin, isLastPin) => {
    const comma = isLastPin ? '' : ',';

    return (
      <Box
        onClick={() => onPinClick(pin)}
        className={!hidePinLink ? classes.pinLink : classes.pinSansLink}
        data-testid="associate-pinbox-link"
        key={pin}
      >
        {`\u00A0${pin + comma}`}
      </Box>
    );
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      className={cx(classes.pinContainer, withMargin && classes.containerMargin)}
      data-testid="associate-pinbox-container"
    >
      <Typography className={classes.pinTitle}>{boxName}:</Typography>
      {isSinglePin ? renderPinLink(pins, true) : pins.map((pin, i) => renderPinLink(pin, i === pins.length - 1))}
    </Box>
  );
};

PinBox.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  boxName: PropTypes.string,
  pins: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  withMargin: PropTypes.bool,
  additionalFnOnClick: PropTypes.func,
  dataForCache: PropTypes.shape({}),
};

PinBox.defaultProps = {
  classes: {},
};

export default PinBox;
